export const STORAGE_KEY_TAXFIX_ANNOUNCEMENT_MODAL_VISIBLE = 'taxfixAnnouncementModalVisible'
export const STORAGE_KEY_TAXFIX_ANNOUNCEMENT_MODAL_SEEN = 'taxfixAnnouncementModalSeen'
export const STORAGE_KEY_GBB_RETURNING_CUSTOMER_ANNOUNCEMENT_MODAL_SEEN = 'gbbReturningCustomerAnnouncementModalSeen'
